import { Timeout } from "./timeout"

export function delayedClick(
    node: HTMLElement,
    { delay = 50, callback }: { delay?: number; callback: (e: PointerEvent) => void },
) {
    const timeout = new Timeout(delay)
    const handleClick = (evt: PointerEvent) => {
        if (timeout.pending) return
        if (evt.target !== node) return
        callback(evt)
    }

    node.addEventListener("pointerup", handleClick, { capture: true })

    return {
        destroy() {
            node.removeEventListener("pointerup", handleClick)
        },
    }
}
